import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../material/material.module';
import {NgModule} from '@angular/core';
import {KeyAccountSecondStepComponent} from './key-account-second-step.component';

@NgModule({
  declarations: [KeyAccountSecondStepComponent],
  exports: [KeyAccountSecondStepComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})

export class KeyAccountSecondStepModule {
}
